module.exports = __webpack_public_path__ + "static/media/right-hand-moving.8a1fcad3.png";